/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Authenticate } from '../fn/account/authenticate';
import { Authenticate$Params } from '../fn/account/authenticate';
import { GenerateTwoFactorKey } from '../fn/account/generate-two-factor-key';
import { GenerateTwoFactorKey$Params } from '../fn/account/generate-two-factor-key';
import { JwTokenModel } from '../models/jw-token-model';
import { Logout } from '../fn/account/logout';
import { Logout$Params } from '../fn/account/logout';
import { Me } from '../fn/account/me';
import { Me$Params } from '../fn/account/me';
import { OneTimePasswordModel } from '../models/one-time-password-model';
import { RefreshToken } from '../fn/account/refresh-token';
import { RefreshToken$Params } from '../fn/account/refresh-token';
import { RegisterTwoFactor } from '../fn/account/register-two-factor';
import { RegisterTwoFactor$Params } from '../fn/account/register-two-factor';
import { SendOneTimePassword } from '../fn/account/send-one-time-password';
import { SendOneTimePassword$Params } from '../fn/account/send-one-time-password';
import { Test } from '../fn/account/test';
import { Test$Params } from '../fn/account/test';
import { Update } from '../fn/account/update';
import { Update$Params } from '../fn/account/update';
import { UpdatePassword } from '../fn/account/update-password';
import { UpdatePassword$Params } from '../fn/account/update-password';
import { UpdateProfileImage } from '../fn/account/update-profile-image';
import { UpdateProfileImage$Params } from '../fn/account/update-profile-image';
import { UserModel } from '../models/user-model';
import { VerifyTwoFactor } from '../fn/account/verify-two-factor';
import { VerifyTwoFactor$Params } from '../fn/account/verify-two-factor';

@Injectable({ providedIn: 'root' })
export class AccountApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAccountTestGet()` */
  static readonly ApiAccountTestGetPath = '/api/Account/Test';

  /**
   * Reuturns a 200 OK  "pong" response to indicate the service is running.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Test()` instead.
   *
   * This method doesn't expect any request body.
   */
  Test$Response(params?: Test$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Test(this.http, this.rootUrl, params, context);
  }

  /**
   * Reuturns a 200 OK  "pong" response to indicate the service is running.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Test$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  Test(params?: Test$Params, context?: HttpContext): Observable<void> {
    return this.Test$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAccountMeGet()` */
  static readonly ApiAccountMeGetPath = '/api/Account/Me';

  /**
   * Get the user login profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Me()` instead.
   *
   * This method doesn't expect any request body.
   */
  Me$Response(params?: Me$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModel>> {
    return Me(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the user login profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Me$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  Me(params?: Me$Params, context?: HttpContext): Observable<UserModel> {
    return this.Me$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModel>): UserModel => r.body)
    );
  }

  /** Path part for operation `apiAccountUpdatePut()` */
  static readonly ApiAccountUpdatePutPath = '/api/Account/Update';

  /**
   * Updates the user login information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Update()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Update$Response(params?: Update$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModel>> {
    return Update(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates the user login information.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Update$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Update(params?: Update$Params, context?: HttpContext): Observable<UserModel> {
    return this.Update$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModel>): UserModel => r.body)
    );
  }

  /** Path part for operation `apiAccountUpdatePasswordPost()` */
  static readonly ApiAccountUpdatePasswordPostPath = '/api/Account/UpdatePassword';

  /**
   * Updates the user password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UpdatePassword()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UpdatePassword$Response(params?: UpdatePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<JwTokenModel>> {
    return UpdatePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates the user password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `UpdatePassword$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UpdatePassword(params?: UpdatePassword$Params, context?: HttpContext): Observable<JwTokenModel> {
    return this.UpdatePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<JwTokenModel>): JwTokenModel => r.body)
    );
  }

  /** Path part for operation `apiAccountUpdateProfileImagePost()` */
  static readonly ApiAccountUpdateProfileImagePostPath = '/api/Account/UpdateProfileImage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UpdateProfileImage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UpdateProfileImage$Response(params?: UpdateProfileImage$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModel>> {
    return UpdateProfileImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `UpdateProfileImage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UpdateProfileImage(params?: UpdateProfileImage$Params, context?: HttpContext): Observable<UserModel> {
    return this.UpdateProfileImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModel>): UserModel => r.body)
    );
  }

  /** Path part for operation `apiAccountAuthenticatePost()` */
  static readonly ApiAccountAuthenticatePostPath = '/api/Account/Authenticate';

  /**
   * Authenticate with credentials and retrives access token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Authenticate()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Authenticate$Response(params?: Authenticate$Params, context?: HttpContext): Observable<StrictHttpResponse<JwTokenModel>> {
    return Authenticate(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticate with credentials and retrives access token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Authenticate$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Authenticate(params?: Authenticate$Params, context?: HttpContext): Observable<JwTokenModel> {
    return this.Authenticate$Response(params, context).pipe(
      map((r: StrictHttpResponse<JwTokenModel>): JwTokenModel => r.body)
    );
  }

  /** Path part for operation `apiAccountVerifyTwoFactorPost()` */
  static readonly ApiAccountVerifyTwoFactorPostPath = '/api/Account/VerifyTwoFactor';

  /**
   * POST request with  2-factor authentication codes.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `VerifyTwoFactor()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  VerifyTwoFactor$Response(params?: VerifyTwoFactor$Params, context?: HttpContext): Observable<StrictHttpResponse<JwTokenModel>> {
    return VerifyTwoFactor(this.http, this.rootUrl, params, context);
  }

  /**
   * POST request with  2-factor authentication codes.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `VerifyTwoFactor$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  VerifyTwoFactor(params?: VerifyTwoFactor$Params, context?: HttpContext): Observable<JwTokenModel> {
    return this.VerifyTwoFactor$Response(params, context).pipe(
      map((r: StrictHttpResponse<JwTokenModel>): JwTokenModel => r.body)
    );
  }

  /** Path part for operation `apiAccountRegisterTwoFactorPost()` */
  static readonly ApiAccountRegisterTwoFactorPostPath = '/api/Account/RegisterTwoFactor';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RegisterTwoFactor()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  RegisterTwoFactor$Response(params?: RegisterTwoFactor$Params, context?: HttpContext): Observable<StrictHttpResponse<JwTokenModel>> {
    return RegisterTwoFactor(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RegisterTwoFactor$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  RegisterTwoFactor(params?: RegisterTwoFactor$Params, context?: HttpContext): Observable<JwTokenModel> {
    return this.RegisterTwoFactor$Response(params, context).pipe(
      map((r: StrictHttpResponse<JwTokenModel>): JwTokenModel => r.body)
    );
  }

  /** Path part for operation `apiAccountGenerateTwoFactorKeyPost()` */
  static readonly ApiAccountGenerateTwoFactorKeyPostPath = '/api/Account/GenerateTwoFactorKey';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GenerateTwoFactorKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  GenerateTwoFactorKey$Response(params?: GenerateTwoFactorKey$Params, context?: HttpContext): Observable<StrictHttpResponse<OneTimePasswordModel>> {
    return GenerateTwoFactorKey(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GenerateTwoFactorKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GenerateTwoFactorKey(params?: GenerateTwoFactorKey$Params, context?: HttpContext): Observable<OneTimePasswordModel> {
    return this.GenerateTwoFactorKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<OneTimePasswordModel>): OneTimePasswordModel => r.body)
    );
  }

  /** Path part for operation `apiAccountSendOneTimePasswordPost()` */
  static readonly ApiAccountSendOneTimePasswordPostPath = '/api/Account/SendOneTimePassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SendOneTimePassword()` instead.
   *
   * This method doesn't expect any request body.
   */
  SendOneTimePassword$Response(params?: SendOneTimePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SendOneTimePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SendOneTimePassword$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  SendOneTimePassword(params?: SendOneTimePassword$Params, context?: HttpContext): Observable<void> {
    return this.SendOneTimePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAccountRefreshTokenPost()` */
  static readonly ApiAccountRefreshTokenPostPath = '/api/Account/RefreshToken';

  /**
   * POST requests with a refresh token returning a new JWT access token with user details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RefreshToken()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  RefreshToken$Response(params?: RefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<JwTokenModel>> {
    return RefreshToken(this.http, this.rootUrl, params, context);
  }

  /**
   * POST requests with a refresh token returning a new JWT access token with user details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RefreshToken$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  RefreshToken(params?: RefreshToken$Params, context?: HttpContext): Observable<JwTokenModel> {
    return this.RefreshToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<JwTokenModel>): JwTokenModel => r.body)
    );
  }

  /** Path part for operation `apiAccountLogoutPost()` */
  static readonly ApiAccountLogoutPostPath = '/api/Account/Logout';

  /**
   * Revoke access token and remove cookies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Logout()` instead.
   *
   * This method doesn't expect any request body.
   */
  Logout$Response(params?: Logout$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Logout(this.http, this.rootUrl, params, context);
  }

  /**
   * Revoke access token and remove cookies.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Logout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  Logout(params?: Logout$Params, context?: HttpContext): Observable<void> {
    return this.Logout$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
